import { render, staticRenderFns } from "./SettingsP2PNotifications.vue?vue&type=template&id=4a0150f2&scoped=true&"
import script from "./SettingsP2PNotifications.vue?vue&type=script&lang=js&"
export * from "./SettingsP2PNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SettingsP2PNotifications.vue?vue&type=style&index=0&id=4a0150f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0150f2",
  null
  
)

export default component.exports